import { useSnackbar } from 'notistack';

export const useCopyToClipboard = () => {
  const { enqueueSnackbar } = useSnackbar();

  const copyToClipboard = ({ text, onSuccess, onError }) =>
    navigator.clipboard.writeText(text).then(
      () => {
        enqueueSnackbar('Copied');
        onSuccess();
      },
      () => {
        enqueueSnackbar({
          message: 'Failed to copy',
          variant: 'error',
        });
        onError();
      },
    );

  return { copyToClipboard };
};
